export type Booking = {
  id: number;
  bookingId: number;
  date: string;
  status: BookingStatus;
  startHour: number;
  endHour: number;
  firstname?: string;
  lastname?: string;
  email: string;
  phone?: string;
  roomId?: number;
  externalId: string;
  realCapacity: number;
  capacity: number;
  bookingPrincipalId?: number;
};

export enum BookingStatus {
  PENDING = 'PENDING',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  CANCELLED = 'CANCELLED',
}
